export const CANVAS_SIZES = {
  "4x6": {
    landscape: { width: 432, height: 288 },
    portrait: { width: 288, height: 432 }
  },
  "6x9": {
    landscape: { width: 648, height: 432 },
    portrait: { width: 432, height: 648 }
  },
  "6x11": {
    landscape: { width: 792, height: 432 },
    portrait: { width: 432, height: 792 }
  }
}

export const INK_FREE_ZONES = {
  "4x6": {
    landscape: { width: 197, height: 142, right: 16, bottom: 15 },
    portrait: { width: 197, height: 142, right: 16, bottom: 15 }
  },
  "6x9": {
    landscape: { width: 288, height: 171, right: 20, bottom: 18 },
    portrait: { width: 288, height: 171, right: 20, bottom: 18 }
  },
  "6x11": {
    landscape: { width: 288, height: 171, right: 20, bottom: 18 },
    portrait: { width: 288, height: 171, right: 20, bottom: 18 }
  }
}

export const BG_SIZE_OPTIONS = {
  "cover": "cover",
  "contain": "contain",
  "100%": "100% 100%",
  "auto": "auto",
  "50%": "50%",
  "200%": "200%"
}

export function getCanvasDimensions(size, orientation) {
  return CANVAS_SIZES[size]?.[orientation] || CANVAS_SIZES["4x6"].landscape
}

export function renderBackground(canvas, background) {
  if (background.type === "gradient") {
    canvas.style.background = `linear-gradient(${background.angle || 135}deg, ${background.color1} 0%, ${background.color2} 100%)`
  } else if (background.type === "image" && background.url) {
    const size = BG_SIZE_OPTIONS[background.size] || "cover"
    const position = background.position || "center"
    canvas.style.background = `url('${background.url}') ${position}/${size} no-repeat`
  } else {
    canvas.style.background = background.color || "#ffffff"
  }
}

export function applyCanvasSize(frontCanvas, backCanvas, inkFreeZone, size, orientation) {
  const dims = CANVAS_SIZES[size]?.[orientation] || CANVAS_SIZES["4x6"].landscape
  frontCanvas.style.width = `${dims.width}px`
  frontCanvas.style.height = `${dims.height}px`
  backCanvas.style.width = `${dims.width}px`
  backCanvas.style.height = `${dims.height}px`

  const inkFree = INK_FREE_ZONES[size]?.[orientation] || INK_FREE_ZONES["4x6"].landscape
  inkFreeZone.style.width = `${inkFree.width}px`
  inkFreeZone.style.height = `${inkFree.height}px`
  inkFreeZone.style.right = `${inkFree.right}px`
  inkFreeZone.style.bottom = `${inkFree.bottom}px`
}
